export const mutation_add_user_tenant = `
mutation addUserTenant($tenantId: String!, $userId: String!, $type: String!, $tenantTipoId: Int!) {
    insert_user_tenant_one(object: { UserId: $userId, TenantId: $tenantId, Type: $type, TenantTipoId: $tenantTipoId}) {
        Id
        UserId
        TenantId
        Type
        TenantTipoId
        base_tipo_tenant {
            Value
        }
    }
}`;
export const mutation_update_user_tenant = `
mutation updateUserTenant($tenantId: String!, $userId: String!, $tenantTipoId: Int, $type: String!) {
    update_user_tenant(where: {
        TenantId: {_eq: $tenantId}, UserId: {_eq: $userId}
    },
        _set: {
            TenantTipoId: $tenantTipoId,
            Type: $type
        }) {
        returning {
            Id
            UserId
            TenantId
            Type
            TenantTipoId
            base_tipo_tenant {
            Value
            }
        }
    }
}`;
export const mutation_update_user_tenant_Type = `
mutation updateUserTenant($tenantId: String!, $userId: String!, $type: String!) {
    update_user_tenant(where: {
        TenantId: {_eq: $tenantId}, UserId: {_eq: $userId}
    },
        _set: {            
            Type: $type
        }) {
        returning {
            Id
            UserId
            TenantId
            Type
            TenantTipoId
            base_tipo_tenant {
            Value
            }
        }
    }
}`